const lang = {
  challenge: {
    detail: {
      chall_detail_parti: "Participants",
      chall_detail_reward: "Rewards",
      chall_detail_reward_item: "Items",
      chall_detail_reward_badges: "Badges",
      chall_detail_reward_badge: "Badge",
      chall_detail_reward_point: "Points",
      chall_detail_goal: "Goal",
      chall_detail_dist: "Distance",
      chall_detail_workout: "Workout",
      chall_detail_workout_detail: "Eligible Workouts",
      chall_detail_intro: "Introduction",
      chall_detail_rank: "Leaderboard",
      chall_detail_btn_join: "Join",
      chall_detail_time: "Ends In",
      chall_detail_time_days: "Days",
      chall_detail_status_my: "My Status",
      chall_detail_status_team: "Team Status",
      chall_detail_status_rank: "Ranking",
      chall_detail_status_progress: "Progress",
      chall_detail_status_duration: "Duration",
      chall_detail_status_dist: "Distance",
      chall_detail_status_cal: "Calories",
      common_steps_low: "Steps",
      common_rep_count: "Rep Count",
      chall_detail_status_day: "Workout Days",
      chall_detail_status_best: "Best Result",
      chall_detail_status_contribution: "My Contribution",
      chall_detail_btn_try: "Try Again",
      chall_detail_btn_start: "Start Challenge",
      chall_detail_btn_continue: "Continue Challenge",
      chall_detail_btn_expired: "Challenge Expired",
      chall_detail_reward_item_claim: "Claim",
      chall_detail_reward_badge_display: "Display",
      chall_detail_toast_unstart: "Challenge not started",
      chall_detail_toast_end: "Challenge has ended",
      chall_detail_rank_empty:
        "No ranking data, start your challenge and refresh the leaderboard.",
      chall_detail_workout_collection_mt: "Specific Collection",
      chall_detail_workout_route: "Route Info",
      chall_detail_reward_mt: "All Rewards",
      chall_detail_workout_outrun: "Outdoor Running",
      chall_detail_workout_outcycle: "Outdoor Cycling",
      chall_detail_workout_outwalk: "Outdoor Walking",
      chall_detail_workout_yoga: "Yoga",
      chall_detail_workout_cardio: "Cardio",
      chall_detail_workout_strength: "Strength",
      chall_detail_workout_stretch: "Stretching",
      chall_detail_workout_run: "Treadmill",
      chall_detail_workout_cycle: "Cycling",
      chall_detail_workout_row: "Rower",
      chall_detail_workout_ellipt: "Elliptical",
      chall_detail_workout_step: "Stepper",
      chall_detail_workout_rnr: "Row-N-Ride",
      chall_detail_workout_minibike: "Mini Bike",
      chall_detail_workout_ski: "Ski Machine",
      chall_detail_workout_jump: "Jump Rope",
      chall_detail_workout_vibration_treadmill: "Vibration Treadmill",
      chall_detail_product_recommend: "Product Recommendation",
      chall_detail_version_update_note: "This version doesn’t support this feature. Please update.",
      chall_detail_workout_stair: 'Stair Climber',
      chall_detail_workout_slider: 'Slider Climber',

      chall_detail_workout_runcour: "Running Courses",
      chall_detail_workout_cyclecour: "Cycling Courses",
      chall_detail_workout_elliptcour: "Elliptical Courses",
      chall_detail_workout_rowcour: "Rowing Courses",
      chall_detail_workout_stepcour: "Stepper Courses",
      chall_detail_workout_prenatal: "Prenatal Courses",
      chall_detail_workout_postpartum: "Postpartum Courses",
      chall_detail_workout_meditation: "Meditation Courses",
      chall_detail_workout_rnrcourses: "Row-N-Ride Courses",
      chall_detail_workout_audio: "Audio Courses",
      chall_detail_workout_pilates: "Pilates",
      chall_detail_workout_climber: "Climber Course",


      chall_detail_workout_all: "All workouts tracked by the Sunnyfit app.",
      chall_detail_workout_collection:
        "Work out with courses from this collection",
      chall_detail_goal_intro:
        "Exercise for {times} days, {value} {type} each day.",
      chall_detail_team_join_mt: "Join A Team",
      chall_detail_team_create: "Create Team",
      chall_detail_team_join_conf: "Join Team",
      chall_detail_team_create_cxl: "Cancel",
      chall_detail_team_create_conf: "Save",
      chall_detail_team_user_follow: "Follow",
      chall_detail_team_user_assign: "Assign As Captain",
      chall_detail_team_user_remove: "Remove From Team",
      chall_detail_team_leave: "Leave Team",
      chall_detail_team_user_following: "Following",
      chall_detail_team_leave_note: "Are you sure you want to leave this team?",
      chall_detail_team_leave_cxl: "Cancel",
      chall_detail_team_leave_conf: "Confirm",
      chall_detail_team_me: "Me",
      chall_detail_team_leave_toast:
        "Please assign the captain role to one of your teammates.",
      chall_detail_team_join_toast: "Please select a team",
      chall_detail_team_join_toast_full:
        "The team you selected is full. Please select another team or create a new team.",
      chall_detail_team_create_toast: "Please enter your team name.",
      chall_detail_result_descrip_goal_com_1: "Congratulations!",
      chall_detail_result_descrip_goal_com_single: `Your hard work has paid off. Let’s keep the momentum going!`,
      chall_detail_result_descrip_goal_com_team: `Your team's hard work has paid off. Let's keep the momentum going!`,
      chall_detail_result_descrip_goal_incom_1: " Keep pushing! 💪",
      chall_detail_result_descrip_goal_incom_2: `Take a breath, reset, and let's tackle the next one together!`,
      chall_detail_result_descrip_other1_1: `Wow, you're at the top! `,
      chall_detail_result_descrip_other1_single:
        "Your dedication has paid off. Keep leading the way and inspiring others!",
      chall_detail_result_descrip_other1_team: `Your team's dedication has paid off. Keep leading the way and inspiring others!`,
      chall_detail_result_descrip_other2_1: "Good Work! 💪",
      chall_detail_result_descrip_other2_single: `You are {rank} place! Way to go!`,
      chall_detail_result_descrip_other2_team: `Your team is {rank} place! Way to go!`,
      chall_detail_result_descrip_other3_single: "You are {rank} place!",
      chall_detail_result_descrip_other3_team: "Your team is {rank} place!",
      chall_detail_result_descrip_other3_2: `Keep going, and let's aim for an even higher rank next time!`,
      chall_detail_result_reward: `Rewards Received`,
      chall_detail_result_done: `Done`,
      chall_detail_result_share: `Share`,
      chall_detail_result_reward_badge: `Badges`,
      chall_detail_result_reward_point: `Points`,
      chall_detail_result_reward_item: `Items`,
      chall_detail_workout_collection_time: "Estimated Time",
      chall_detail_start_workout: "Start A Workout",
      badge_detail_display: `Display in Profile`,
      badge_detail_remove: `Remove from Profile`,
      badge_detail_display_toast: `Now Displaying in Your Profile`,
      badge_detail_remove_toast: `Removed from Profile Display`,
      invite_from: `Invite From`,
      invite_from_friend: `Friends`,
      invite_from_contact: `Contacts`,
      invite_from_more: `More`,
      address_edit_mt: "Shipping Address",
      address_edit_note: "All data will be encrypted",
      address_edit_country: "Country / Region",
      address_edit_name: "Name",
      address_edit_street: "Street address",
      address_edit_apt: "Apt/Suite/Other(Optional)",
      address_edit_city: "City",
      address_edit_state: "State",
      address_edit_code: "ZIP Code",
      address_edit_phone: "Phone Number",
      address_edit_btn: "Submit",
      address_edit_state_select_mt: "Select State",
      address_edit_check: "Check Address",
      address_edit_check_note:
        "Please verify address to ensureproper delivery. Lost prizes will notbe replaced.",
      address_edit_check_cxl: "Cancel",
      address_info_mt: "Shipping Address",
      address_info_name: "Name",
      address_info_phone: "Phone",
      address_info_address: "Address",
      common_courses_count: "Courses",
      challenge_exchange_title1: 'Are you interested in spending ',
      challenge_exchange_title2: ' points to join?',
      challenge_exchange_mypt: 'My Points: ',
      challenge_exchange_button1: '%s Points Join',
      challenge_exchange_button2: 'Earn more points',
      challenge_exchange_button3: 'Cancel',
      challenge_exchange_toast: 'Join success',

      chall_detail_workout_select_route: 'Select Route',
      chall_detail_workout_route_select: 'Select This Route',
      chall_detail_workout_change_route: 'Change',
      chall_detail_workout_my_route: 'My Route',
      chall_detail_status_scoring_rules: 'Scoring Rules',

      chall_scoring_rules_main_title: "Score Breakdown🏆",
      chall_scoring_rules_goal_title: "🏁 Completion (s% pts)",
      chall_scoring_rules_goal_descrip: "Reach the target distance to secure your completion points.\nStatus: Earned immediately upon reaching the distance.",
      chall_scoring_rules_speed_title: "⚡ Speed (max s% pts)",
      chall_scoring_rules_speed_descrip: "The faster you finish, the higher you score! Your speed bonus is calculated at the exact moment you hit the target distance.\nTip: Shorter Finish Time = Higher Rank.",
      chall_scoring_rules_bonus_title: "🎯 Repetition Bonus (max s% pts)",
      chall_scoring_rules_bonus_descrip: "Consistency pays off! Earn +1 extra point every time you repeat this challenge (Up to s% pts).",
      chall_scoring_rules_ranking_title: "🥇 Ranking Rules",
      chall_scoring_rules_ranking_descrip: "Total Score: Your final score = Goal + Speed + Bonus (Capped at 100 pts).\nLock-in: Scores are locked the moment you reach the goal. Continued movement is for exercise tracking only and won't change your rank.\nTie-breaker: If scores are equal, the faster Finish Time wins.",
      
      share_challenge_poster_bub: '🔥 Join me in this Challenge! 🏆️',
      share_poster_sologn: 'Get Free Fit, Grow with Sunny Fam 👉',
      share_poster_challenge_success: 'Challenge Success',

      common_block_pop_title: "Usage Limited",
      chall_detail_join_limit_content: 'Due to the detection of your abnormal data-farming behavior, in order to ensure the fairness of the community, your Challenge functions have been restricted.',
      me_contact: 'Contact Us',
    },
  },
  workout: {
    collection: {
      detail: {
        workout_course_collection_detail_mt: "Collection",
        workout_wt_collection_detail_mt: "World Tour Collection",
        workout_course_collection_detail_count: "Courses",
        workout_course_collection_detail_limit: "Limited Time Course",
      },
    },
  },
  support: {
    equipment: {
      detail: {
        equip_support_equip_main: "Support Equipment",
        equip_support_equip_enter_tips: "Please Enter Your Equipment Model:",
        equip_support_equip_enter_content: "Enter Model...",
        equip_support_equip_tips_main: "Tips",
        equip_support_equip_tips_content: "If you don't know the device model, you can check the label of the body, as shown in the image below.",
        equip_support_equip_contact_us_btn: "Contact Us",
        equip_support_equip_view_courses_btn: "View Courses",
        btn_common_ok: "OK",
        btn_common_search: "Search",
      },
    },
  },
  contact: {
    detail: {
      contact_us_mt: "Contact Us",
      contact_us_feedback: "Submit Feedback",
      contact_us_note:
        "Submit your feedback or issue and we’ll get back to you within 2 business days!",
      contact_us_issue_type: "I need help with",
      contact_us_issue_type_input: "Please select issue",
      contact_us_name: "Full Name",
      contact_us_name_input: "Type your full name here",
      contact_us_equip: "Equipment model",
      contact_us_equip_input: "Enter Equipment Model No.",
      contact_us_email: "Email",
      contact_us_email_input: "Type your email here",
      contact_us_describe: "Describe lssue",
      contact_us_describe_input: "Leave your message here",
      contact_us_image: "Image/Video Attachment",
      contact_us_contact_info: "Contact information",
      btn_common_send: "Send",
      btn_common_submit: "Submit",
      contact_us_issue_type_mt: "lssue Type",
      contact_us_issue_type_equip: "Equipment Issues",
      contact_us_issue_type_equip_note: "Meter issue/Damaged/Missing Parts",
      contact_us_issue_type_app: "App Issues",
      contact_us_issue_type_app_note: "Features/User Experience",
      contact_us_issue_type_suggest: "Suggestions",
      contact_us_issue_type_suggest_note: "Add courses / Add features",
      contact_us_issue_type_equip_meter: "Meter Issue",
      contact_us_issue_type_equip_damage: "Damaged/Missing Part(s)",
      contact_us_issue_type_app_regist: "Registration/Sign Up",
      contact_us_issue_type_app_connect: "Bluetooth Connection",
      contact_us_issue_type_app_googlefit: "Google Fit",
      contact_us_issue_type_app_applehealth: "Apple Health",
      contact_us_issue_type_app_video: "Video/Audio Playback",
      contact_us_issue_type_app_plan: "Plans and Scheduled Courses/Programs",
      contact_us_issue_type_app_account: "Account and Profile",
      contact_us_issue_type_app_update: "Version Update",
      contact_us_issue_type_app_data: "Data Anomalies",
      contact_us_issue_type_app_other: "Other App Issues",
      contact_us_issue_type_app_wifi: "Wi-Fi Connection",
      contact_us_result_mt: "Thank you for your feedback!",
      contact_us_result_st: "We’ll get back to you within 2 business days.",
      btn_common_done: "Done",
      btn_common_next: "Next",

      btn_common_camera: "Camera",
      btn_common_photo_album: "Choose photo from album",
      btn_common_video_album: "Choose video from album",
      btn_common_cancel: "Cancel",

      camera_note_main: "Camera Permission",
      camera_note_content: "We need access to your Camera to upload content.",
      photo_note_main: "Photo Permission",
      photo_note_content:
        "We need access to your Photos to upload content.",

      photo_note_btn_open_settings: "Open Settings",
      uploading_note_main: "Uploading your feedback...",
      uploading_note_schedule: "{currentUploadIndex} of {totalUploadCount} files uploaded",
      uploading_note_tips: "Video file may take longer",

      album_attach_upload_failed_toast: "Upload failed. Try again.",
      album_attach_image_toast: "You can attach up to {number} images",
      album_attach_image_length_toast: "You can select images within {size} MB each",
      album_attach_video_toast: "You can attach up to {number} video",
      album_attach_video_length_toast1: "Please select a video within {number} seconds.",
      album_attach_video_size_toast: "Please select a video within {number} MB.",

    },
  },
  workoverview: {
    detail: {
      common_steps: "Steps",
      common_steps_low: "steps",
      workout_result_mt: "Workout Data",
      workout_result_cal_in: "The Calories In",
      workout_result_hamburger: "Hamburger",
      workout_result_hamburger_note:
        "A {name} equals approximately {value} calories",
      workout_result_data_time: "Time",
      workout_result_data_dis: "Distance",
      workout_result_data_cal: "Calories",
      workout_result_data_height: "Height",
      workout_result_data_floors: "Floors",
      workout_result_data_cal_note:
        "The calories burned shown on your app is based on your height and weight, so it may be inconsistent with the data on your equipment.",
      workout_result_data_floor_note: "One floor is about 2.5 meters.",
      workout_result_data_steps: "step",
      workout_result_data_stroke: "Strokes",
      workout_result_data_stride: "Stride Count",
      workout_result_data_max_jumps: "Max Jumps",
      workout_result_data_avg: "Avg",
      workout_result_data_max: "Max",
      workout_result_data_hr: "HR",
      workout_result_data_hr_analysis: "Heart Rate Analysis",
      workout_result_data_hr_zone: "Zone {index}",
      workout_result_data_speed: "Speed",
      workout_result_data_pace: "Pace",
      workout_result_pace_fast: "Fastest",
      workout_result_data_resist: "Resistance",
      workout_result_data_cadence: "Cadence",
      workout_result_data_spm: "SPM",
      workout_result_data_str: "Stroke Rate",
      workout_result_data_rep: "Rep Count",
      workout_result_data_reps: "Reps",
      workout_result_evaluate: "Evaluate",
      workout_result_post: "Post My Result",
      workout_result_share_video: "Share Great Video",
      workout_result_wu: "Warmup",
      workout_result_main: "Main Workout",
      workout_result_cd: "Cooldown",
      workout_result_treadmill: "Treadmill Training",
      workout_result_bike: "Indoor Bike Ride",
      workout_result_elliptical: "Elliptical Training",
      workout_result_rnr: "Row-N-Ride",
      workout_result_rower: "Rower Training",
      workout_result_stepper: "Stepper Training",
      workout_result_data_incline: "Incline",
      workout_result_run: "Outdoor Running",
      workout_result_walk: "Outdoor Walking",
      workout_result_cycling: "Outdoor Cycling",
      workout_result_result_workout: "Workout",
      workout_result_chall_score: "Score",
      workout_result_map_hide_note: "Map will be hidden when you share.",
      workout_result_on_equipment: "On-equipment",
      workout_result_off_equipment: "Off-equipment",
      btn_common_done: "Done",
      btn_common_share: "Share",
      btn_common_try_again: "Try again",
      common_completed: "Completed",
      common_remaining: "Remaining",
      share_common_open: "Open",
      social_user_follow: "Follow",
      social_user_following: "Following",
      share_common_join_us: "Join Us",
      workout_result_movement_tag: "Movement",
      workout_result_movement_note: "This movements training customized from Al plan. Do you want to create your exclusive plan?",
      btn_try_now: "Try Now",
      workout_result_share: 'Share My Result',
      workout_result_movement_feedback: "Feedback",
      workout_result_movement_feedback_mt: "Feedback Helps Us Improve",
      workout_result_movement_feedback_tip: "How do you feel about this training?",
      workout_result_rpe_ask: "Tell me how this session felt.",
      workout_result_rpe_easy: "Easy",
      workout_result_rpe_challenge: "Challenge",
      workout_result_rpe_level1: "Effortless",
      workout_result_rpe_level2: "Very Easy",
      workout_result_rpe_level3: "Comfortable",
      workout_result_rpe_level4: "Breaking a Sweat",
      workout_result_rpe_level5: "Bit Out of Breath",
      workout_result_rpe_level6: "Getting Tough",
      workout_result_rpe_level7: "Hard to Talk",
      workout_result_rpe_level8: "Heavy Breathing",
      workout_result_rpe_level9: "Almost Maxed Out",
      workout_result_rpe_level10: "Nothing Left",
      workout_result_rpe_submit: "Send",
      workout_result_rpe_submit_fail:
        "Failed to submit. Please try again.",
      workout_result_rpe_loading_line1: "RPE: {n}/10. Got it!",
      workout_result_rpe_loading_line2:
        "I'm reviewing your workout...",
      workout_result_coach_insight: "Coach Insight",
      workout_result_ai_rpe_caption: "RPE : {n} / 10",
      workout_result_rpe_note:
        "RPE stands for Rate of Perceived Exertion. It reflects how hard your workout felt on a scale from 1 to 10.",
      workout_result_ask_coach: "Ask Coach",
      btn_common_submit: "Submit",
    },
  },
  midYearReport: {
    workoutData_burnCalories: "Total Calories Burned",
    workoutData_workoutTimes: "Total # of Workouts",
    workoutData_workoutDays: "Total Days With Workouts",
    workoutData_workoutDuration: "Total Workout Time",

    community_title: `Thank you for contributing to 
    and being part of the SunnyFit community!`,
    community_friendsRanking: "Ranking Among Friends",
    community_rankOpen: "Top ",
    community_rankEnd: " among friends",
    community_postShares: "Posts Shared",
    community_likesReceived: "Posts Liked",
    community_share_unit: "Posts",
    community_like_unit: "Likes",


    favoriteWorkout_totalNumberOfWorkouts: " Workouts Completed",
    favoriteWorkout_equivalentToSeveralBurgers: "Calories Burned Equal To",
    favoriteWorkout_totalDistance_Metric: "Total distance in kilometers", //公制距离
    favoriteWorkout_totalDistance_Imperial: "Total distance in miles", //英制距离
    favoriteWorkout_MaxRPMAchieved: "Max RPM Achieved",
    favoriteWorkout_MaxSPMAchieved: "Max SPM Achieved",
    favoriteWorkout_TotalDuration: "Total duration",
    favoriteWorkout_TotalCaloriesBurned: "Calories Burned",
    favoriteWorkout_fastestPace: "Your fastest pace completed",
    favoriteWorkout_fastestCadence: "Your fastest cadence completed",
    favoriteWorkout_maxStrokes: "Your max strokes completed",
    favoriteWorkout_maxFrequency: "Your max frequency completed",
    favoriteWorkout_totalDaysOfWorkout: "Total Days of &*& Workouts",

    favorite_favorite: "Favorite",
    favoriteTrainer_descTime: "Over the past six months, you took workout courses with &*& Sunny Trainers",
    favoriteTrainer_descTrain: "You completed &*& courses with your favorite trainer, &*& !",
    
    favoriteCourses_title: "New courses are added to SunnyFit every week!",
    favoriteCourses_coursesDesc: "That's equivalent to watching &*& movies!",

    noData_title: "SunnyFit Workout Report",
    noData_info: "Unfortunately, the workout data you provided for 2024 is insufficient. ",

    common_share: "Share",
    common_back: "Back",
    common_joinNow: "Join Now",
    common_update: "Please update to the latest version.",
  },
  pointsMall:{
    product:{
      detail: {
        "product_detail_top_title":"Product Details",
        "product_detail_mypoints":"My Points:",
        "product_detail_exchange":"Exchange",
        "product_detail_earn":"Earn More Points",
        "product_detail_stock":"Out Of Stock",
        "product_detail_null_title":"The data is abnormal, please try again later.",
        "product_detail_null_button":"Refresh",
        "product_detail_promotional1": "Limited Ends %s Days",
        "product_detail_promotional2": "Limited | Only %s Left",
        "product_detail_promotional3": "Limited | Out of Stock",
        "product_detail_gift_others": "Gift for Others",
        "product_detail_gift_myself": "Gift for Myself"
      }
    },
    order:{
      detail: {
        "exchange_detail_my_order_title":"My Order",
        "exchange_detail_view_points":"My Points",
        "exchange_detail_discount": "Discount",
        "exchange_detail_expected_deduction":"Expected Deduction",
        "exchange_detail_balance":"Balance",
        "exchange_detail_out_of_stock":"We're currently out of stock for this item. Please check back soon.",
        "exchange_detail_redemption_toast":"The redemption exceeds the limit.",
        "exchange_detail_confirm_exchange":"Confirm Exchange",

        "exchange_successful_title":"Redemption Successful",
        "exchange_successful_goods_send_info":"Your item(s) will be shipped soon. You can check the progress in your order details.",
        "exchange_successful_check_order_detail":"To initiate the redemption process, kindly check your order detail.",
        "exchange_successful_back":"Back",
        "exchange_successful_view":"View Order Detail",

        "orders_history_detail_address_title1":"Phone",
        "orders_history_detail_address_title2":"Address",
        "orders_history_detail_address_title3":"Email",
        "orders_history_null_title": "It is empty here",
        "address_detail_add_shipping_address":"Add Shipping Address",
        "address_detail_add":"Add",
        "address_detail_default":"Default",
        "address_detail_set_as_default":"Set As Default",
        "address_detail_my_address":"My Address",
        "address_detail_delete":"Delete",
        "address_detail_edit":"Edit",
        "address_detail_add_a_shipping_address":"+ Add A Shipping Address",
        "address_detail_delete_tips":"Delete Tips",
        "address_detail_toast":"Are you sure to delete this address?",
        "address_detail_cancel":"Cancel",
        "address_detail_delete":"Delete",

        "shipping_address_title":"Shipping Address",
        "shipping_address_data_encryption_info":"All data will be encrypted",
        "shipping_address_country_region":"Country / Region",
        "shipping_address_first_name":"First Name",
        "shipping_address_first_name_prompt":"Please enter First Name",
        "shipping_address_last_name":"Last Name",
        "shipping_address_last_name_prompt":"Please enter Last Name",
        "shipping_address_address_line_1":"Address Line 1",
        "shipping_address_address_line_1_desc":"Street name and street number, company name",
        "shipping_address_address_line_2":"Address Line 2",
        "shipping_address_address_line_2_sub":"(Optional) ",
        "shipping_address_address_line_2_desc":"Building/Apartment/Suite no, Unit, Floor, etc",
        "shipping_address_state":"State",
        "shipping_address_state_prompt":"Please select State",
        "shipping_address_city":"City",
        "shipping_address_city_prompt":"Please enter City",
        "shipping_address_zip_code":"ZIP code",
        "shipping_address_zip_code_prompt":"Please ZIP code",
        "shipping_address_phone_number":"Phone number",
        "shipping_address_phone_number_prompt":"Please Phone number",
        "shipping_address_email_address":"Email address",
        "shipping_address_email_address_desc":"For receiving shipping information",
        "shipping_address_security_privacy_info":"Security & Privacy",
        "shipping_address_security_privacy_desc":"We maintain industry-standard physical, technical, and administrative measures to safeguard your personal information.",
        "shipping_address_save":"Save",
        "shipping_address_name":"Please enter your First Name and Last Name with 2-32characters.",
        "shipping_address_toast":"We apologize, but our points redemption program is currently only available to users in the 48 contiguous United States.",

      "orders_history_top_title":" Orders History",
      "orders_history_list_view":"View Detail",
      "orders_history_list_date":"Exchange Date:",
      "orders_history_null_button":"Points Exchange",
      "orders_history_detail_top_title":"Order Detail",
      "orders_history_detail_tracking_title":"Tracking Number",
      "orders_history_detail_coupon_code":"Coupon Code",
      "orders_history_detail_coupon_time":"Coupon Expiration Time",
      "orders_history_detail_tracking_state":"Processing",
      "ordershi_history_detail_date_title":"Exchange Date",
      "orders_history_detail_spend_title":"Spend",
      "orders_history_detail_order_title":"Order Number",
      "orders_history_detail_instructions":"Instructions",
      "orders_history_detail_copy":"Copy",
      "orders_history_detail_copy_toast":"Copying Succeeded",
      "orders_history_tab_1":"Exchange Orders",
      "orders_history_tab_2":"Course Orders",

      "invite_reward_order_type":"Referral award",
      "event_reward_order_type":"Event award",

      "rewards_points_toast_error200": "Order created successfully",
      "rewards_points_toast_error302": "Promotion invalid",
      "rewards_points_toast_error404": "The data is abnormal, please try again later.",
      "rewards_points_toast_error412": "The data is abnormal, please try again later.",
      "rewards_points_toast_error999": "The data is abnormal, please try again later.",
      "rewards_points_toast_error14001": "Item discontinued",
      "rewards_points_toast_error14002": "We're currently out of stock for this item.Please check back soon.",
      "rewards_points_toast_error14003": "Insufficient points",
      "rewards_points_toast_error14004": "Redemption exceeds limit",
      "rewards_points_toast_error14005": "Not within promo period",
      "rewards_points_toast_error14006": "Limited promo redemption exhausted",
      "rewards_points_toast_error14008": "The Gift has been claimed",
      "rewards_points_toast_error14010": "Past the claim validity period - Gift has been returned",
      }
    },
  },
  common: {
    common_no_content: "No Content",
    common_loading_failed: "Loading Faild",
    common_refresh: "Refresh",
    common_loading: "Loading",
    common_points: "Points",
    common_intensity_beg: "Beginner",
    common_intensity_int: "Intermediate",
    common_intensity_adv: "Advanced",
    common_no_more_data: "No More Data",
    common_days: "days",
  },
  workoutType: {
    Treadmill: "Treadmill",
    IndoorBike: "Indoor Bike",
    Elliptical: "Elliptical",
    Stepper: "Stepper",
    Rowing: "Rowing",
    RowNRide: "Row-N-Ride",
    Cardio: "Cardio",
    Yoga: "Yoga",
    Strength: "Strength",
    prenatal: "prenatal",
    postpartum: "postpartum",
    meditation: "meditation",
    Audio: "Audio",
    Stretching: "Stretching",
    outdoorRunning: "outdoor running",
    outdoorCycling: "outdoor cycling",
    outdoorWalking: "outdoor walking",
  }
};
export default lang;



// WEBPACK FOOTER //
// ./src/locales/en.js